import { render, staticRenderFns } from "./CardContato.vue?vue&type=template&id=45692928&"
import script from "./CardContato.vue?vue&type=script&lang=js&"
export * from "./CardContato.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports